module.exports = __webpack_public_path__ + "assets/media/day11.84a09803.mp3";